import { render, staticRenderFns } from "./StepInicio.vue?vue&type=template&id=5c70145a&scoped=true&"
import script from "./StepInicio.vue?vue&type=script&lang=js&"
export * from "./StepInicio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../Users/lucianocolucci/Desktop/Share Windows/IngeniAR/WebProject/Syscore-mods/Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c70145a",
  null
  
)

export default component.exports